import React, { useState, createContext, useLayoutEffect, useContext, } from 'react';
import { darkTheme, lightTheme } from '../constants';
import { applyTheme } from '../utils';
const Context = createContext({
    theme: 'dark',
    setTheme: () => { },
});
export const ThemeProvider = ({ children, themes = [], initialTheme, onChange, }) => {
    const themesWithDefault = [...themes];
    if (!themes.find((theme) => theme.name === 'dark')) {
        themesWithDefault.push(darkTheme);
    }
    if (!themes.find((theme) => theme.name === 'light')) {
        themesWithDefault.push(lightTheme);
    }
    const [theme, setThemeInner] = useState(initialTheme || 'dark');
    const setTheme = (value) => {
        if (onChange) {
            onChange(value);
        }
        applyTheme(theme, themesWithDefault);
        setThemeInner(value);
    };
    useLayoutEffect(() => {
        applyTheme(theme, themesWithDefault);
    });
    return (React.createElement(Context.Provider, { value: { theme, setTheme } }, children));
};
export const useTheme = () => {
    const { theme, setTheme } = useContext(Context);
    return { theme, setTheme };
};
//# sourceMappingURL=ThemeManager.js.map